import styled from 'styled-components'
import { Flex } from '../Box'

const StyledBottomNav = styled(Flex)<{ isBlackThemePage: boolean }>`
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 3px 8px;
  background: ${({ isBlackThemePage }) => (isBlackThemePage ? '#111111' : '#00334a')};
  html[data-useragent*='TokenPocket_iOS'] & {
    padding-bottom: 45px;
  }
  z-index: 20;
`

export default StyledBottomNav
